import { render, staticRenderFns } from "./CompletedCallsTable.vue?vue&type=template&id=ce1a09ae&"
import script from "./CompletedCallsTable.vue?vue&type=script&lang=js&"
export * from "./CompletedCallsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports